import { Link } from 'react-router-dom';
import { DEFAULT_LOCALE, translate } from '@formosa/shared/i18n/translate';
import { useOptionalTravelTranslation } from '../../../app/TravelLocaleContext';
import { budgetCategoryLabel } from '../../finance/budgetCategory';
import { formatChatTime } from '../travelChatModel';
import { memberFallbackLabel } from '../../member-display/memberDisplayModel';
import {
  CARD_SCHEMA_V1,
  EXPENSE_RENDERER_KEY,
  cardFallbackText,
  cardSchemaVersion,
  isSupportedCardSchema,
  normalizeExpenseBusinessCard,
} from './travelCardModel';

const UNSUPPORTED = '此卡片目前無法顯示';

export default function ExpenseCardMessage({ message }) {
  const travelLocale = useOptionalTravelTranslation();
  const t = travelLocale?.t || ((key) => translate(DEFAULT_LOCALE, key));
  const card = normalizeExpenseBusinessCard(message?.businessCard);
  if (!card || card.rendererKey !== EXPENSE_RENDERER_KEY) {
    return <p>{cardFallbackText(message, UNSUPPORTED)}</p>;
  }
  if (!isSupportedCardSchema(card)) {
    return (
      <p>
        {cardFallbackText(message, UNSUPPORTED)}
        <span className="visually-hidden"> schema {String(cardSchemaVersion(card))}</span>
      </p>
    );
  }
  if (!card.amountLabel || !card.expenseId) {
    return <p>{cardFallbackText(message, UNSUPPORTED)}</p>;
  }

  const occurred = formatChatTime(card.occurredAt) || String(card.occurredAt || '').replace('T', ' ');

  return (
    <article className="travel-msg-card" aria-label="旅程支出">
      <p className="travel-msg-card__kicker">旅程支出</p>
      <h2 className="travel-msg-card__title">{card.title || cardFallbackText(message, '支出')}</h2>
      {card.categoryCode ? <p>類別：{budgetCategoryLabel(card.categoryCode, t)}</p> : null}
      <p className="travel-msg-card__amount">{card.amountLabel}</p>
      {card.payerMemberId ? <p>付款人：{memberFallbackLabel(card.payerMemberId)}</p> : null}
      {occurred ? <p><time dateTime={card.occurredAt}>{occurred}</time></p> : null}
      {card.status === 'VOIDED' ? <p>狀態：已作廢</p> : null}
      {card.participantCount != null ? <p>參與人數：{card.participantCount}</p> : null}
      {card.splitMethodLabel ? <p>分攤：{card.splitMethodLabel}</p> : null}
      {card.webRoute ? (
        <Link className="travel-msg-card__cta" to={card.webRoute}>
          查看支出
        </Link>
      ) : null}
      <span className="visually-hidden">schema {CARD_SCHEMA_V1}</span>
    </article>
  );
}
